<template>
    <div class="iframe-container">
        <iframe
            :src="jumpLink"
            width="100%"
            height="770px"
            frameborder="0"
            title="天宝打印"
        ></iframe>
    </div>
</template>

<script>
export default {
    name: 'IframeEmbed',
    data(){
      return{
        jumpLink:''
      }
    },
    mounted() {
        const query = this.$route.query;
        this.jumpLink = query.url
    }
};
</script>

<style scoped>
.iframe-container {
    /* max-width: 1200px; */
    margin: 0 auto;
    /* padding: 20px; */
    background-color: #f0f0f0;
    border: 1px solid #ddd;
}
iframe {
    border: none;
    width: 100%;
    /* height: 600px; */
}
</style>